import './polyfills';
import './localization';

import 'font-awesome/css/font-awesome.min.css';
import { Theme } from '@mui/material/styles';
import { LicenseInfo } from '@mui/x-license-pro';
import * as ReactDOM from 'react-dom';

import { Providers } from '~/Providers';

import { App } from './App';
import { unregister } from './serviceWorker';

LicenseInfo.setLicenseKey(
  '0ebd3f62b6c197b941651f7621d4b0b4Tz0xMDA3ODYsRT0xNzYxNzMxNjA4MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=',
);

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}
if (process.env.REACT_APP_BUILD_TARGET !== 'library') {
  ReactDOM.render(
    <Providers>
      <App />
    </Providers>,
    document.getElementById('root'),
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
unregister();

export * from './library';
